module.exports = fox._r("images/banner-cam.png", __webpack_public_path__ + "images/banner-cam.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-file-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/file-loader?name=[path][name].[ext]!./images/banner-cam.png
// module id = 943
// module chunks = 4